<template>
  <div>
    <Toolbar />
    <!-- <div v-if="token == null" class="text-center">
      <a href="/">
        <v-img
          src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
          height="100"
          width="200"
          class="mx-auto"
        ></v-img>
      </a>
    </div>-->
    <div v-if="token != null">
      <v-container v-if="total == null" fluid>
        <div class="text-center pa-5">
          <v-icon size="100">fas fa-shopping-bag</v-icon>
        </div>
        <div class="text-center empty-cart">Ups.. Keranjangmu masih kosong</div>
        <div
          class="text-center empty-cart-side"
        >Udah lihat barang - barang terbaru ? Belum? Yuk, aku temenin</div>
        <div class="text-center my-5">
          <v-btn @click="goTo('/product')" medium dark color="#558B2F">Cari Barang</v-btn>
        </div>
      </v-container>
      <v-container class="container-size-web" v-if="total != null" fluid>
        <v-row>
          <v-flex class="cart-size" xs12 md8 lg8>
            <v-card height="2" color="#A7FFEB"></v-card>
            <div class="mt-3" v-for="cart in carts" :key="cart.id" raised>
              <v-row>
                <v-col class="pa-0" cols="1">
                  <!-- <div class="text-right"><v-checkbox></v-checkbox></div> -->
                </v-col>
                <v-col cols="11">
                  <div>
                    <v-icon class="mr-2" small>fas fa-store</v-icon>
                    {{ cart.nama_toko }}
                  </div>
                  <div style="font-size : 80%;" class="font-weight-thin">Semarang Utara</div>
                </v-col>
              </v-row>
              <div v-for="barang in cart.barang" :key="barang.id">
                <v-row>
                  <v-col class="pa-0" cols="1"></v-col>
                  <v-col class="pa-0" cols="2">
                    <v-avatar size="80" tile>
                      <img :src="getImageUrl(barang.gambar)" alt="John" />
                    </v-avatar>
                  </v-col>
                  <v-col class="pa-0" cols="9">
                    <b class="nama-barang">{{ barang.nama }}</b>
                    <br />
                    <b class="font-harga">{{ barang.harga | currency }}</b>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="1"></v-col>

                  <v-col cols="5">
                    <div v-if="barang.catatan != null" class="font-catatan">
                      <div class="head-catatan">Catatan :</div>
                      {{ barang.catatan }}
                    </div>
                    <!-- <v-btn
                      v-if="barang.catatan == null"
                      @click="catatan = true"
                      color="#E53935"
                      text
                      small
                    >Tulis Catatan untuk Toko</v-btn>-->
                    <!-- <div v-if="catatan == true">
                      <v-text-field
                        label="Catatan untuk Toko (optional)"
                        placeholder="Warna Hitam, Size M"
                      ></v-text-field>
                      <v-btn @click="catatan = false" text small>Tulis</v-btn>
                      <v-btn @click="catatan = false" text small>Batal</v-btn>
                    </div>-->
                  </v-col>
                  <v-col>
                    <div style="float : right;">
                      <v-btn @click="rdcQty(barang)" :disabled="barang.qty == 1" icon color="pink">
                        <v-icon>fas fa-minus-circle</v-icon>
                      </v-btn>
                      <span class="mx-3">{{ barang.qty }}</span>
                      <v-btn @click="addQty(barang)" icon color="pink">
                        <v-icon>fas fa-plus-circle</v-icon>
                      </v-btn>
                      <v-btn @click="clearCart(barang)" class="mx-5" icon color="grey">
                        <v-icon>fas fa-trash</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
              </div>
            </div>
          </v-flex>
          <v-flex class="cart-size" xs12 md4 lg4>
            <v-card v-if="total != 0" class="mt-3" raised>
              <div class="ringkasan-belanja">Ringkasan Belanja</div>
              <v-divider class="mx-5"></v-divider>
              <v-row>
                <v-col class="total-harga">Total Harga</v-col>
                <v-col>
                  <div class="total">{{ cartHeader.total | currency }}</div>
                </v-col>
              </v-row>
              <div class="text-center pa-5">
                <v-btn color="#43A047" @click="validasi(cartHeader)" block dark medium>Beli</v-btn>
              </div>
              <v-divider class="mx-5"></v-divider>
              <div class="text-center pa-5">
                <v-btn block tile outlined color="success">
                  <v-icon left>fas fa-ticket-alt</v-icon>Kupon
                </v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-row>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- <v-footer fixed dark padless>
      <v-card flat tile class="indigo lighten-1 white--text text-center">
        <v-card-text>
          <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="white--text pt-0">
          Phasellus feugiat arcu sapien, et iaculis ipsum elementum sit amet.
          Mauris cursus commodo interdum. Praesent ut risus eget metus luctus
          accumsan id ultrices nunc. Sed at orci sed massa consectetur dignissim
          a sit amet dui. Duis commodo vitae velit et faucibus. Morbi vehicula
          lacinia malesuada. Nulla placerat augue vel ipsum ultrices, cursus
          iaculis dui sollicitudin. Vestibulum eu ipsum vel diam elementum
          tempor vel ut orci. Orci varius natoque penatibus et magnis dis
          parturient montes, nascetur ridiculus mus.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>Vuetify</strong>
        </v-card-text>
      </v-card>
    </v-footer>-->
  </div>
</template>
<script>
import Swal from "sweetalert2";
import Toolbar from "../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      catatan: false,
      isEditing: true,
      overlay: false,
      loading: false,
      loadVal: false,
      valid: true,
      dialog: false,
      service: null,
      qty: 0,
      token: localStorage.getItem("token"),
      userid: localStorage.getItem("user_id"),
      idkeranjang: localStorage.getItem("idkeranjang"),
      total: null,
      carts: [],
      cartHeader: [],
      dataUser: []
    };
  },
  mounted() {
    if (this.userid != null) {
      this.getAlamat();
      this.getCart();
    } else if (this.token == null) {
      this.$router.push("login");
    } else {
      console.log("");
    }
  },

  computed: {
    length() {
      var x = this.carts.length;
      return x;
    },
    subTotal() {
      var subTotal = this.carts.map(cart => {
        if (cart) {
          return cart.harga * cart.qty;
        }
      });
      return subTotal;
    },
    Total() {
      var x = this.subTotal;
      var total = 0;
      for (var i = 0; i < x.length; i++) {
        if (isNaN(x[i])) {
          continue;
        }
        total += Number(x[i]);
      }
      return total;
    },
    berat() {
      var berat = this.carts.map(cart => {
        return cart.berat * cart.qty;
      });
      return berat;
    },
    beratTotal() {
      var x = this.berat;
      var beratTotal = 0;
      for (var i = 0; i < x.length; i++) {
        if (isNaN(x[i])) {
          continue;
        }
        beratTotal += Number(x[i]);
      }
      return beratTotal;
    }
  },
  methods: {
    clicked() {
      alert("bisa");
    },
    getAlamat() {
      fetch("http://meridinet.saebo.id:2082/Login/api/ViewUser/" + this.id)
        .then(response => response.json())
        .then(data => {
          this.dataUser = data;
        });
    },
    getCart() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkoutpro/" +
          this.idkeranjang +
          "/1000"
      )
        .then(response => response.json())
        .then(data => {
          this.carts = data.keranjang;
          this.cartHeader = data;
          this.total = data.total;
          this.overlay = false;
        });
    },

    validasi(data) {
      this.loading = true;
      if (data.total > 0) {
        this.$router.push("cart/shipment");
      } else if (data.total == 0) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Keranjang anda kosong"
        });
      }

      this.loading = false;
    },
    checkout(data) {
      localStorage.setItem("idkeranjang", data.id);
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkout/" +
          data.id +
          "/" +
          this.beratTotal * 1000 +
          "/" +
          this.service
      ).then(response => response.json());

      localStorage.setItem("kurir", this.service);
      localStorage.setItem("beratTotal", this.beratTotal * 1000);

      this.$router.push("konfirmasi");
    },
    addQty(data) {
      this.overlay = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addchart", {
        method: "POST",
        body: JSON.stringify({
          userid: this.userid,
          nama_toko: data.nama_toko,
          idbarang: data.idbarang,
          qty: 1,
          harga: data.harga,
          kurir: ""
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        response.json();
        this.getCart();
        this.overlay = false;
      });
    },
    rdcQty(data) {
      this.overlay = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/tabel/delchart", {
        method: "POST",
        body: JSON.stringify({
          userid: this.userid,
          nama_toko: data.nama_toko,
          idbarang: data.idbarang,
          qty: 1,
          harga: data.harga
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        response.json();
        this.getCart();
        this.overlay = false;
      });
    },
    back() {
      window.history.back();
    },
    goTo(e) {
      this.$router.push(e);
    },

    clearCart(data) {
      this.overlay = true;
      Swal.fire({
        title: "Barang akan dihapus dari keranjang",
        text: "Apakah anda yakin ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Hapus"
      }).then(result => {
        if (result.value) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/delchart", {
            method: "POST",
            body: JSON.stringify({
              userid: this.userid,
              nama_toko: data.nama_toko,
              idbarang: data.idbarang,
              qty: data.qty,
              harga: data.harga
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }).then(response => {
            response.json();
            this.getCart();
            this.overlay = false;
          });

          // Swal.fire("Deleted!", "Barang dihapus dari keranjang.", "success");

          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },

    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    }
  }
};
</script>
<style scoped>
.head-catatan {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 80%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #a7a7a7;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.font-catatan {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #a7a7a7;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.font-qty {
  font-size: 120%;
}
.font-harga {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #f44336;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.nama-barang {
  font-family: Tahoma, Geneva, sans-serif;
  font-size: 125%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.empty-cart {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 125%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.empty-cart-side {
  font-family: "Comic Sans MS", cursive, sans-serif;
  font-size: 100%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
@media only screen and (max-width: 768px) {
  .empty-cart {
    font-family: Verdana, Geneva, sans-serif;
    font-size: 100%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .empty-cart-side {
    font-family: "Comic Sans MS", cursive, sans-serif;
    font-size: 80%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .web {
    display: none;
  }
  .ringkasan-belanja {
    padding: 3%;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 125%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .total-harga {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 100%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #959595;
    font-weight: 400;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    padding-left: 7%;
  }
  .total {
    float: right;
    margin-right: 20px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 100%;
    letter-spacing: -0.8px;
    word-spacing: 2px;
    color: #090909;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .cart-size {
    padding: 0px;
  }
}
@media screen and (min-width: 1024px) {
  .cart-size {
    padding: 20px;
  }
  .container-size-web {
    padding-left: 15%;
    padding-right: 15%;
  }
  .ringkasan-belanja {
    padding: 5%;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 125%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .total-harga {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 100%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #959595;
    font-weight: 400;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    padding-left: 7%;
  }
  .total {
    float: right;
    margin-right: 10px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 100%;
    letter-spacing: -0.8px;
    word-spacing: 2px;
    color: #090909;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
}
</style>
